import React from "react";
import Stack from "@mui/material/Stack";
import ExpertAnswerStatistics from "./ExpertAnswersStatistics";
import ExpertRank from "./ExpertRank";
import ExpertCuration from "./ExpertCuration";
import ExpertAnswers from "./ExpertAnswers";
import QuestionsAndAnswersGraph from "./QuestionAndAnswersGraph";
import RatingsReceivedByExpertOverview from "../../../GraphComponent/RatingsReceivedByExpertOverview";
const containerStyle = {
  width: "100%",
  margin: "auto",
  marginTop: "1%",
  marginBottom: "1%",
  border: "1px solid #E0E2E6",
  background: "#FFFFFF",
  borderRadius: "12px",
  boxShadow: "0px 4px 16px 0px #1018280F",
  padding: "28px",

};
function ExpertOverview() {
  return (
    // <Stack spacing={4} style={{ paddingTop: "15px" }}>
    <div style={containerStyle}>
    <div style={{width:'100%',marginLeft:'auto',marginRight:'auto',paddingTop:'15px'}}>
      <QuestionsAndAnswersGraph />
      <ExpertAnswerStatistics />
      <ExpertRank />
      <RatingsReceivedByExpertOverview />
      <ExpertAnswers />
      <ExpertCuration />
      </div>
      </div>
    // </Stack>
  );
}

export default ExpertOverview;
